import React from 'react';
import '../../css/Shared/Input.css';

const Input = props => {
    return (
        <input class="input"
            {...props}
            type={props.type}
            className={props.class}
            style={{ ...props.style }}

        />
    );
};

export default Input;